<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import router from '../router';
import TwOverlay from '../components/TwOverlay';

export default {
  name: 'Dashboard',
  data() {
    return {
      selected: undefined,
    };
  },
  components: {
    TwOverlay,
  },
  computed: {
    ...mapState({
      xmlJobsOverview: state => state.xmlChannelStatus.xmlJobsOverview,
      filterStatus: state => state.xmlChannelStatus.filter.statusOptions,
    }),
    ...mapGetters({
      jobStatusListItems: 'xmlChannelStatus/jobStatusList',
    }),
  },
  methods: {
    ...mapActions({
      setBreadcrumbs: 'nav/setBreadcrumbs',
      updateXmlChannelFilterStatus: 'xmlChannelStatus/updateXmlChannelFilterStatus',
      getXmlJobsOverview: 'xmlChannelStatus/getXmlJobsOverview',
    }),
    updateAndRoute(status, values) {
      if (status === 'total') {
        this.updateXmlChannelFilterStatus([]);
      } else {
        this.updateXmlChannelFilterStatus(values);
      }
      router.push({ name: 'XmlChannelStatus' });
    },
    getAmountForListItem(keys) {
      if (Object.keys(this.xmlJobsOverview.items).length === 0) {
        return '-';
      }

      let sum = 0;
      keys.forEach((key) => {
        if (this.xmlJobsOverview.items[key]) {
          sum += this.xmlJobsOverview.items[key];
        }
      });
      return sum;
    },
    refreshJobOverview() {
      if (this.xmlJobsOverview.loading) {
        return;
      }
      this.getXmlJobsOverview();
    },
  },
  created() {
    this.setBreadcrumbs({
      breadcrumbs: [
        { text: this.$t('menu.dashboard.pages.dashboard'), to: '', disabled: true },
      ],
      title: this.$t('menu.dashboard.title'),
    });
  },
  mounted() {
    if (Object.keys(this.xmlJobsOverview.items).length === 0) {
      this.getXmlJobsOverview();
    }
  },
};
</script>

<template>
  <v-flex xs-12 dashboard>
    <v-progress-circular
      class="dashboard__loading"
      v-if="xmlJobsOverview.loading"
      :active="xmlJobsOverview.loading"
      indeterminate
    />
    <tw-overlay :visible="xmlJobsOverview.loading"></tw-overlay>
    <v-container>
      <h2 class="d-inline-block">{{ $t('dashboard.jobStatus') }}</h2>
      <v-btn
        @click="refreshJobOverview"
        :disabled="xmlJobsOverview.loading"
        class="right mt-0"
        icon
      >
        <v-icon :class="{ 'icon-spin': xmlJobsOverview.loading }">refresh</v-icon>
      </v-btn>
    </v-container>
    <v-container pt-1>
      <v-layout v-if="!xmlJobsOverview.error" row justify-space-between>
        <v-flex v-for="item in jobStatusListItems" :key="item.id" shrink>
          <span class="subheading font-weight-bold mt-1">
            {{ getAmountForListItem(item.values) }}
          </span>
          <v-chip
            @click="updateAndRoute(item.badge.label, item.values)"
            @mouseover="selected = item.badge.label"
            @mouseleave="selected = undefined"
            :color="item.badge.color"
            :text-color="item.badge.text"
            :selected="selected === item.badge.label"
          >
            <span class="pa-2 subheading dashboard__link">
              {{$t(`badges.${item.badge.label}`)}}
            </span>
          </v-chip>
        </v-flex>
      </v-layout>
      <v-layout v-else row>
        <span>{{ $t('dashboard.error') }}</span>
      </v-layout>
    </v-container>
  </v-flex>
</template>

<style lang="scss">
  .dashboard {
    position: relative;

    &__loading {
      position: absolute;
      z-index:11;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &__link {
      cursor: pointer;
    }
  }
</style>




// WEBPACK FOOTER //
// src/pages/Dashboard.vue